/** Định dạng hiển thị của màn P2P. Mốc giờ trong dữ liệu đã là giờ VN (ISO có +07:00) nên cắt chuỗi, không đổi múi giờ. */

export const usd = (n: number): string => n.toLocaleString('en-US');

/** `2026-10-31` → `31/10` */
export function dm(iso: string): string {
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
}

/** `2026-10-23T23:59+07:00` → `23/10 23:59` */
export function dmHm(iso: string): string {
  return `${dm(iso)} ${iso.slice(11, 16)}`;
}

/** Còn bao ngày: "còn 8 ngày" · "hết hạn" */
export function daysLeftLabel(d: number): string {
  return d < 0 ? `quá ${-d} ngày` : d === 0 ? 'hôm nay' : `còn ${d} ngày`;
}

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** `2026-10-22T08:10+07:00` → `22/Oct/2026 08:10` */
export function dmy(iso: string): string {
  return `${iso.slice(8, 10)}/${MON[Number(iso.slice(5, 7)) - 1]}/${iso.slice(0, 4)} ${iso.slice(11, 16)}`;
}

/** Số kiểu VN (1.972 · 0,7) — như `nf()` của board Mint-MarketNews. */
export const viNum = (n: number, frac = 0): string => n.toLocaleString('de-DE', { minimumFractionDigits: frac, maximumFractionDigits: frac });
